import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import StatusPill from "../components/StatusPill";

export default function Invoices() {
  const [items, setItems] = useState([]);

  async function load() {
    const { data } = await api.get("/invoices");
    setItems(data);
  }
  useEffect(() => { load(); }, []);

  async function markPaid(id) {
    await api.patch(`/invoices/${id}?status=paid&payment_method=Card`);
    load();
  }

  const totalUnpaid = items.filter((i) => i.status === "unpaid").reduce((s, i) => s + Number(i.amount), 0);
  const totalPaid = items.filter((i) => i.status === "paid").reduce((s, i) => s + Number(i.amount), 0);

  return (
    <div className="p-8 lg:p-10" data-testid="invoices-page">
      <header className="mb-8">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Billing</div>
        <h1 className="font-display text-4xl font-semibold tracking-tight">Invoices</h1>
      </header>

      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs text-slate-500">Outstanding</div>
          <div className="font-display text-3xl font-semibold tracking-tight text-violet-700" data-testid="total-unpaid">${totalUnpaid.toFixed(2)}</div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs text-slate-500">Collected</div>
          <div className="font-display text-3xl font-semibold tracking-tight text-emerald-700" data-testid="total-paid">${totalPaid.toFixed(2)}</div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              <th className="px-6 py-3">Customer</th>
              <th className="px-6 py-3">Service</th>
              <th className="px-6 py-3">Due</th>
              <th className="px-6 py-3">Amount</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {items.length === 0 && (
              <tr><td colSpan={6} className="px-6 py-12 text-center text-slate-500" data-testid="invoices-empty">
                No invoices yet. Complete a job to create an invoice.
              </td></tr>
            )}
            {items.map((i) => (
              <tr key={i.id} data-testid={`invoice-row-${i.id}`}>
                <td className="px-6 py-3 font-medium text-slate-900">{i.customer_name}</td>
                <td className="px-6 py-3 text-slate-600 capitalize">{(i.service_type || "—").replace("_", " ")}</td>
                <td className="px-6 py-3 text-slate-600">{i.due_date}</td>
                <td className="px-6 py-3 font-semibold">${Number(i.amount).toFixed(2)}</td>
                <td className="px-6 py-3"><StatusPill status={i.status}/></td>
                <td className="px-6 py-3 text-right">
                  {i.status === "unpaid" && (
                    <button onClick={() => markPaid(i.id)} data-testid={`mark-paid-${i.id}`}
                      className="text-xs px-3 py-1 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md transition-colors">
                      Mark Paid
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
